// removed by extract-text-webpack-plugin
module.exports = {"layout":"src-layouts----layout-module---layout---2Ck4m"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/layout.module.css
// module id = 358
// module chunks = 114276838955818